import React, { useContext, useState } from "react";
import {
  VegaButtonLink,
  VegaBox,
  VegaModal,
  VegaFlex,
  VegaButton,
} from "@heartlandone/vega-react";
import { _fetch } from "Chore/Request";
import { PATH } from "Chore/Apis";
import { HubContext } from "Redux/Context/context";
import { toggleGlobalModalAction } from "Redux/Actions/actions";
import { reloadActivitiesAction } from 'Redux/Actions/actions';
import { VegaNotify } from "@heartlandone/vega";

const { PUT_ACTIVITY } = PATH;

function CancelActivityAction({ activity , callback = null }) {
  const { id } = activity;
  const { globalModalDispatch } = useContext(HubContext);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const { reloadActivitiesDispatch } = useContext(HubContext);

  const _onCancelActivityClick = () => {
    setIsConfirmOpen(false);
    _toggleModal(true);
    _fetch({
      api: PUT_ACTIVITY(id),
      method: "DELETE",
    })
      .then(async (res) => {
        if (res.code === 2200) {
          reloadActivitiesDispatch(
            reloadActivitiesAction({reloadBy: 'cancel-activity'})
          );
          if(callback !== null){
            callback();
          }
        }else{
          await VegaNotify.open({
            warning: "error",
            duration: 3000,
            message: res.message,
          });
        }
      })
      .finally(() => {
        _toggleModal(false);
      });
  };

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({ isShow }));
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label="Cancel Activity"
        icon="far fa-xmark"
        onVegaClick={() => setIsConfirmOpen(true)}
      />
      <CancelActivityConfirm
        isOpen={isConfirmOpen}
        setIsOpen={(isOpen) => setIsConfirmOpen(isOpen)}
        onOk={_onCancelActivityClick}
      />
    </VegaBox>
  );
}

function CancelActivityConfirm({ isOpen, setIsOpen, onOk }) {
  return (
    <VegaModal
      size={480}
      backdrop={`static`}
      open={isOpen}
      onVegaClose={() => setIsOpen(false)}
    >
      <div slot="modal-title">
        <div>Cancel Activity</div>
      </div>

      <div slot="modal-content">
        <VegaFlex direction={"col"} gap={"size-20"}>
          <VegaBox className="f-weight-500">Are you sure you want to cancel this activity?</VegaBox>
          <VegaBox className="f-weight-500">
            A notification email will be sent to all registers after
            cancellation.
          </VegaBox>
        </VegaFlex>
      </div>
      <div slot="modal-footer">
        <VegaFlex direction="row" gap="size-12" justifyContent={`end`}>
          <VegaButton
            label="No"
            variant="secondary"
            size="small"
            onVegaClick={() => setIsOpen(false)}
          />
          <VegaButton
            label="Yes"
            size="small"
            onVegaClick={() => onOk()}
          />
        </VegaFlex>
      </div>
    </VegaModal>
  );
}

export default CancelActivityAction;
